import { Tag } from 'antd'

import {
  NewbornInvestigationPeriod,
  NewbornPlanInvestigationStatus,
  PregnancyActionStatus,
  PregnancyMonitoringPlanInvestigationStatus,
  PregnancyPeriod
} from 'src/api/requests'
import { useLocales } from 'src/locales'

type Props = {
  status?: PregnancyActionStatus
}

type InvestigationProps = {
  status?:
    | PregnancyMonitoringPlanInvestigationStatus
    | NewbornPlanInvestigationStatus
}

type PeriodProps = {
  status?: PregnancyPeriod
}

type NewBornPeriodProps = {
  status?: NewbornInvestigationPeriod
}

const PregnancyStatusMap = {
  [PregnancyActionStatus.CESAREAN_SECTION]: 'warning',
  [PregnancyActionStatus.INTERRUPTED_PREGNANCY]: 'error',
  [PregnancyActionStatus.LOST_PREGNANCY]: 'error',
  [PregnancyActionStatus.NATURAL_BIRTH]: 'success',
  [PregnancyActionStatus.PREGNANT_PERSON]: 'success'
}

const PregnancyInvestigationsStatusMap = {
  [PregnancyMonitoringPlanInvestigationStatus.TO_DO]: 'warning',
  [PregnancyMonitoringPlanInvestigationStatus.NEED_TO_INVESTIGATE]: 'error',
  [PregnancyMonitoringPlanInvestigationStatus.IN_PROGRESS]: 'blue',
  [PregnancyMonitoringPlanInvestigationStatus.EXPIRED]: 'error',
  [PregnancyMonitoringPlanInvestigationStatus.COMPLETED]: 'success'
}

const PregnancyPeriodStatusMap = {
  [PregnancyPeriod.INITIAL]: 'warning',
  [PregnancyPeriod.OPTIONAL]: 'blue',
  [PregnancyPeriod.FOR28WEEKS]: 'green',
  [PregnancyPeriod.FOR36WEEKS]: 'green'
}

const NewBornPeriodStatusMap = {
  [NewbornInvestigationPeriod.AT_FORTY_EIGHT_HOURS]: 'warning',
  [NewbornInvestigationPeriod.AT_SIX_TO_EIGHT_WEEKS]: 'blue',
  [NewbornInvestigationPeriod.AT_NINE_MONTHS]: 'green'
}

export const PregnancyStatusTag = ({ status }: Props) => {
  const { t } = useLocales()

  if (!status) return '-'

  const color = PregnancyStatusMap[status]

  return (
    <Tag color={color}>
      {t(`pregnancy.pregnancy_actions_statuses.${status}`)}
    </Tag>
  )
}

export const PregnancyInvestigationsStatusTag = ({
  status
}: InvestigationProps) => {
  const { t } = useLocales()

  if (!status) return '-'

  const color = PregnancyInvestigationsStatusMap[status]

  return (
    <Tag color={color}>{t(`pregnancy.investigation_status.${status}`)}</Tag>
  )
}

export const PregnancyPeriodStatusTag = ({ status }: PeriodProps) => {
  const { t } = useLocales()

  if (!status) return '-'

  const color = PregnancyPeriodStatusMap[status]

  return <Tag color={color}>{t(`pregnancy.period_status.${status}`)}</Tag>
}

export const NewBornPeriodStatusTag = ({ status }: NewBornPeriodProps) => {
  const { t } = useLocales()

  if (!status) return '-'

  const color = NewBornPeriodStatusMap[status]

  return (
    <Tag color={color}>{t(`pregnancy.newborn_period_status.${status}`)}</Tag>
  )
}
